import * as React from 'react';

import {FormStagesWrapper} from '../../forms';
import type {ActiveItem} from '../../types';

import {SalesAutomationEditorSidebar} from './sidebar/sales-automation-editor-sidebar';

type OwnProps = {
    isNew: boolean;
} & ActiveItem;

type Props = OwnProps;

export class StageEditor extends React.PureComponent<Props> {
    sidebarFormSubmitBtnRef: HTMLInputElement | null | undefined;

    render() {
        const {isNew, entityId} = this.props;

        return (
            <SalesAutomationEditorSidebar
                onSave={this.handleSidebarFormSave}
                title={isNew ? 'New stage' : 'Edit stage'}
            >
                <FormStagesWrapper
                    formSubmitBtnRef={(node) => {
                        this.sidebarFormSubmitBtnRef = node;
                    }}
                    entityId={entityId}
                />
            </SalesAutomationEditorSidebar>
        );
    }

    handleSidebarFormSave = () => {
        if (this.sidebarFormSubmitBtnRef) {
            this.sidebarFormSubmitBtnRef.click();
        }
    };
}
